import { render, staticRenderFns } from "./formDesign.vue?vue&type=template&id=62ddead6&scoped=true&"
import script from "./formDesign.vue?vue&type=script&lang=js&"
export * from "./formDesign.vue?vue&type=script&lang=js&"
import style0 from "./formDesign.vue?vue&type=style&index=0&id=62ddead6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ddead6",
  null
  
)

export default component.exports